import { Box, ColorToken, HStack, IconButton, Text, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

interface NetWorthItemProps {
  isLoading: boolean;
  hasSelectedCustomer: boolean;
  adjustedNetWorth?: number;
  netWorthError: boolean;
  netWorthRefresher: () => void;
}

export const NetWorthItem: React.FC<NetWorthItemProps> = ({
  isLoading,
  hasSelectedCustomer,
  adjustedNetWorth,
  netWorthError,
  netWorthRefresher,
}) => {
  const getText = () => {
    if (isLoading) {
      return 'Carregando...';
    }
    if (netWorthError) {
      return 'Erro ao carregar patrimônio líquido.';
    }
    if (!hasSelectedCustomer) {
      return 'Selecione o cliente';
    }
    return Utils.Mask.Money(adjustedNetWorth);
  };

  const getBackgroundColor = (): ColorToken => {
    if (hasSelectedCustomer && !isLoading && !netWorthError) {
      return 'neutral.lightest';
    }
    return 'background';
  };

  return (
    <VStack space="stack.nano">
      <Text variant="semibold" color="neutral.darkest">
        Patrimônio líquido
      </Text>

      <Box px="inline.xxxs" py="stack.nano" borderRadius="sm" bg={getBackgroundColor()}>
        <HStack justifyContent="space-between" alignItems="center">
          <Text color="neutral.medium">{getText()}</Text>
          {netWorthError && (
            <IconButton
              testId="refresh-net-worth"
              p={0}
              variant="unstyled"
              icon="Refresh"
              iconSize="xxxs"
              iconColor="brand.tertiary.principal"
              onPress={netWorthRefresher}
            />
          )}
        </HStack>
      </Box>
    </VStack>
  );
};
